import { jsx as _jsx } from "react/jsx-runtime";
import { Widget } from "./Widget";
import { StackContainer } from "./styles/WidgetStyle";
export var WidgetsStack = function (_a) {
    var widgetsMap = _a.widgetsMap;
    var widgets = Array.from(widgetsMap.values());
    return (_jsx(StackContainer, { className: "widget-stack", children: widgets.map(function (widget) { return (_jsx(Widget, { identifier: widget.identifier, type: widget.type, status: widget.status, logs: widget.logs, onClose: function () { return widget.onClose(widget.identifier); }, taskId: widget.taskId, onSuccess: widget.onSuccess, automaticallyDownload: widget.automaticallyDownload }, widget.identifier)); }) }));
};
